"use client";

import { useRouter, useSearchParams } from "next/navigation";
import { FilterItem, FilterSearch } from "./NewsFilter";
import qs from "qs";
import type { ComponentPropsWithoutRef } from "react";
import type { newsFilter } from "app/actions";

function filtersFromSearchParams(
  params: URLSearchParams | null,
): newsFilter & { p?: number } {
  if (!params) return {};
  const filter: newsFilter & { p?: number } = {};
  const search = params.get("search");
  const category = params.get("category");
  const topic = params.get("topic");
  const year = params.get("year");
  const page = params.get("p");

  if (search?.trim()) filter.search = search.trim();
  if (category) {
    const n = Number(category);
    if (!Number.isNaN(n)) filter.category = n;
  }
  if (topic) {
    const n = Number(topic);
    if (!Number.isNaN(n)) filter.topic = n;
  }
  if (year) {
    const n = Number(year);
    if (!Number.isNaN(n)) filter.year = n;
  }
  if (page) {
    const n = Number(page);
    if (!Number.isNaN(n)) filter.p = n;
  }
  return filter;
}

function pushNewsFilter(
  router: ReturnType<typeof useRouter>,
  next: newsFilter & { p?: number },
) {
  // Drop empty/undefined keys so resetting a select clears that query param
  const clean: Record<string, string | number> = {};
  if (next.search?.trim()) clean.search = next.search.trim();
  if (next.category != null) clean.category = next.category;
  if (next.topic != null) clean.topic = next.topic;
  if (next.year != null) clean.year = next.year;
  if (next.p) clean.p = next.p;
  const str = qs.stringify(clean);
  router.push(str ? `/news?${str}` : "/news");
}

export function SidebarSearch() {
  const router = useRouter();
  const searchParams = useSearchParams();
  const filter = filtersFromSearchParams(searchParams);

  return (
    <FilterSearch
      filter={filter}
      update_filter={(fn) => {
        pushNewsFilter(router, fn(filter));
      }}
    />
  );
}

export function SidebarItem(
  props: Omit<ComponentPropsWithoutRef<typeof FilterItem>, "update_filter" | "filter"> & {
    filter?: newsFilter;
  },
) {
  const router = useRouter();
  const searchParams = useSearchParams();
  const filter = filtersFromSearchParams(searchParams);

  return (
    <FilterItem
      {...props}
      filter={filter}
      update_filter={(fn) => {
        // Preserve other active filters when changing one select
        pushNewsFilter(router, { ...fn(filter), p: undefined });
      }}
    />
  );
}
